import { useMe } from "@/api/services/main/auth";
import { learnerSchema, learnerSchemaWithCompany } from "@/features/learner/schema/learnerSchema";
import { useMemo } from "react";

// RSO user -> companyId required, company user -> no companyId field
export const useGetLearnerSchema = () => {
  const { data: meResult } = useMe();
  const isRsoUser = !!meResult?.data?.rsoId;

  const schema = useMemo(() => {
    return isRsoUser ? learnerSchemaWithCompany : learnerSchema;
  }, [isRsoUser]);

  return { learnerSchema: schema, isRsoUser };
};
